import { render, staticRenderFns } from "./BPAttachment.vue?vue&type=template&id=0e621428"
import script from "./BPAttachment.vue?vue&type=script&lang=js"
export * from "./BPAttachment.vue?vue&type=script&lang=js"
import style0 from "./BPAttachment.vue?vue&type=style&index=0&id=0e621428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports